const locale = {
	heroTitle: 'Swiss-Type CNC Precision Machining',
	heroSubtitle: 'Cincom L20 · φ1–20mm Small-Diameter Parts · Medical · Connectors · Aerospace',
	heroCtaProducts: 'View Products',
	heroCtaContact: 'Request a Quote',
	featuresTitle: 'Why Choose Us',
	feature1Title: 'Swiss-Type CNC (Cincom L20)',
	feature1Desc:
		'Equipped with Citizen Cincom L20 Swiss-type sliding headstock CNC lathes, we specialize in small-diameter precision parts from φ1 to 20mm, achieving tolerances as tight as ±0.005mm. Swiss-type machining excels at long slender shafts, medical probes, connector pins, aerospace fasteners, and any component requiring a high length-to-diameter ratio or ultra-tight tolerances. Materials include stainless steel, aluminum alloy, copper, titanium, carbon steel, and engineering plastics — from prototype to production.',
	feature2Title: 'Full-Process Integration',
	feature2Desc:
		'QingYi offers a true one-stop service — from engineering design and technical drawings through Swiss-type CNC machining to complete post-processing including grinding, polishing, anodizing, electroplating (nickel, chrome, zinc), and sandblasting. Simply provide your drawings or samples, and we handle everything from start to finish. This eliminates the hassle of coordinating multiple vendors, significantly shortens lead times, and reduces overall project management costs.',
	feature3Title: 'ISO 9001 Certified',
	feature3Desc:
		'QingYi holds ISO 9001:2015 certification, operating under a standardized production process with full quality traceability. Before every shipment, parts undergo rigorous dimensional inspection (including CMM measurement) and visual checks, with complete production records and inspection reports retained. Ongoing process audits and continuous improvement activities ensure that every delivered part meets customer specifications and international quality standards.',
	aboutTitle: 'About QingYi Precision',
	about:
		'Founded in Shulin, New Taipei City, Taiwan, QingYi Precision Co., Ltd. is a specialist Swiss-type CNC machining manufacturer equipped with the Citizen Cincom L20 sliding headstock lathe, focused on small-diameter precision components from φ1 to 20mm. Our capabilities span the entire manufacturing process — from product design, engineering, and technical drawings to CNC machining, grinding, polishing, and electroplating — providing customers with a complete, single-source manufacturing solution.\n\nWe serve customers in medical devices, electronic connectors, aerospace fasteners, watch components, and precision instruments — industries that demand the highest dimensional accuracy on small, complex parts. With tolerances held consistently to ±0.005mm, ISO 9001:2015 certification, and a commitment to continuous improvement, QingYi delivers dimensionally accurate, quality-assured parts on time — every time. We are your trusted precision manufacturing partner in Taiwan.\n\nIn terms of materials, QingYi works confidently with stainless steel (SUS), brass, copper, aluminum alloys, and engineering plastics, complemented by heat treatment and a range of surface finishes. From low-volume prototyping and pilot runs to high-volume production, we maintain consistent dimensional accuracy and surface quality. Every step — from incoming material inspection and in-process checks to full-dimension inspection before shipment — is fully documented and traceable. Backed by flexible capacity and responsive engineering communication, we help customers shorten development cycles and speed time to market. Believing that quality is born from attention to detail, we build long-term, dependable partnerships founded on professionalism and integrity.',
	isoTitle: 'ISO 9001 Quality Management',
	isoClick: 'Click to view certificate',
	mineralsTitle: 'Responsible Minerals Sourcing Policy',
	mineralsClick: 'Click to view policy',
	servicesTitle: 'Core Services',
	services: [
		'Product Design',
		'Engineering',
		'Technical Drawing',
		'Swiss-type CNC Machining',
		'Grinding',
		'Polishing',
		'Electroplating',
		'CMM Inspection'
	],
	stats: [
		{ value: 'Cincom L20', label: 'Swiss-type Lathe' },
		{ value: 'φ1–20mm', label: 'Diameter Range' },
		{ value: '±0.005mm', label: 'Stable Tolerance' },
		{ value: 'ISO 9001', label: 'Certified' }
	],
	milestonesTitle: 'Our Journey',
	milestonesSubtitle: 'Continuous improvement, steady growth',
	milestones: [
		{
			year: '2021',
			title: 'Official Website Launched',
			desc: 'Launched a trilingual (Traditional/Simplified Chinese and English) website with an online product showcase and mobile support, giving customers worldwide instant insight into our machining capabilities.'
		},
		{
			year: '2022',
			title: 'Data-Driven Operations',
			desc: 'Integrated Google Analytics 4 to understand customer sources and behavior, continuously refining our digital marketing and service experience.'
		},
		{
			year: '2024',
			title: 'ISO 9001:2015 Certified',
			desc: 'Achieved international quality management certification with standardized production processes and full quality traceability for consistent delivery.'
		},
		{
			year: '2026',
			title: 'Website Redesign',
			desc: 'Redesigned the interface and content with stronger SEO and branding, fully showcasing our Cincom L20 Swiss-type lathes and small-diameter precision parts.'
		},
		{
			year: '2026',
			title: 'Responsible Minerals Sourcing Policy',
			desc: 'Adopted RBA and OECD guidelines and publicly committed to a conflict-free, responsible supply chain alongside our customers.'
		}
	],
	productsTitle: 'Featured Products',
	productsSubtitle: 'Swiss-Type CNC Precision Parts (Cincom L20)',
	viewAllProducts: 'View All Products',
	specsTitle: 'Machine Capabilities',
	spec2Lbl: 'Small-Diameter Machining Range',
	spec3Lbl: 'Precision Tolerance',
	specTblDiameter: 'Max. Machining Diameter',
	specTblLength: 'Max. Machining Length',
	specTblSpindle: 'Spindle Speed',
	specTblRotaryTool: 'Rotary Tool Speed',
	specTblTools: 'Max. Tool Capacity',
	specTblLFV: 'LFV Chip Control',
	specTblLFVVal: 'Front & Back Spindle',
	pageTitle: 'QingYi Precision | Swiss-Type CNC Machining Specialist',
	pageDesc: 'QingYi Precision specializes in Swiss-type CNC machining with Citizen Cincom L20 lathes. φ1–20mm small-diameter precision parts, ±0.005mm tolerance, ISO 9001:2015 certified. Serving medical, connector, and aerospace industries.',
	pageKeywords: 'Swiss-type CNC, Cincom L20, precision machining, small-diameter parts, medical parts, connector machining, aerospace parts, Taiwan manufacturing, ISO9001, QingYi Precision',
	contactTitle: 'Contact Us',
	address: 'No. 5, Aly. 35, Ln. 1, Beinei St., Shulin Dist., New Taipei City, Taiwan',
	phone: '+886-966-686-161 / +886-2-8687-2058',
	fax: '+886-2-8687-2059',
	email: 'qingyi106@gmail.com'
};

export default locale;
